import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sessionService } from "redux-react-session";

import CommonAuthHeader from "./CommonAuthHeader";
import EmailVerification from "../auth/EmailVerification";
import BackdropLoader from "../backdropLoader/BackdropLoader";
import { loadingMsg } from "../messages";
import LinkStatus from "../linkStatus/LinkStatus";
import {
  callAPIInterface,
  getTimestamp,
  handleAfterLoginProcess,
  setUpdatedSessionData,
  checkLinkStatus,
  sourceTelegramApp,
} from "../constants";

const OptionsEmailVerification = () => {
  const navigate = useNavigate();
  const { search, state, pathname } = useLocation();
  const [isLink, setIsLink] = useState(false);
  const [verifyEmailScreen, setVerifyEmailScreen] = useState(false);
  const [linkStatus, setLinkStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");

  const getLinkFromURL = async (user) => {
    const searchURL = search.replace("+", "%2B");
    const data = new URLSearchParams(searchURL);

    const link = user?.verification_link || data.get("id");
    const userEmail = user?.email || data.get("email");

    if (!link) {
      setIsLink(false);
      if (state?.email) {
        setVerifyEmailScreen(true);
        setEmail(state.email);
      } else {
        navigate("/");
      }
      return;
    }

    setIsLink(true);
    setIsLoading(true);

    try {
      await sessionService
        .saveUser({ verification_link: link, email: userEmail })
        .then((_res) => navigate("/verify-email"));
      const res = await checkLinkStatus(link);
      if (res) {
        setEmail(res.new_email);
        const response = await callAPIInterface(
          "POST",
          "/verify-email",
          JSON.stringify({
            verification_link: link,
          })
        );
        response.timestamp = getTimestamp();
        await setUpdatedSessionData(response);

        if (response.mfa_enabled) {
          navigate(
            response.mfa_configurations ? "/two-factor" : "/two-factor-setup",
            {
              state: {
                from: "/login",
                isFromVerifyEmailPage: true,
              },
            }
          );
        } else {
          await handleAfterLoginProcess(navigate, true);
        }
      }
    } catch (e) {
      const errors = e?.response?.data?.errors;
      setEmail(userEmail);
      const errorType = errors && errors[0].type.toLowerCase();
      if (errorType === "link_expired") setLinkStatus("expired");
      else if (errorType === "link_already_used") setLinkStatus("used");
      else navigate("/");
    } finally {
      setIsLoading(false);
    }
  };

  const getUser = async () => {
    const user = await sessionService
      .loadUser()
      .then((res) => res)
      .catch((_e) => {});
    getLinkFromURL(user);
  };

  useEffect(() => {
    const searchURL = search.replace("+", "%2B");
    //search URL comes from app
    let locationData = new URLSearchParams(searchURL);

    const source = locationData.get("source");

    locationData.delete("source"); // deleted because when it is redirected from app it will first redirected to web and then telegram mini app from the same page

    //converted to base64 format to create start param value to open telegram mini app.
    const base64URL = btoa(`${pathname}?${locationData.toString()}`);

    if (source === sourceTelegramApp) {
      window.location.href = `https://t.me/${process.env.REACT_APP_TELEGRAM_MINI_APP_USERNAME}?startapp=${base64URL}`;
    } else {
      getUser();
    }
  }, []);

  return isLink ? (
    <>
      <BackdropLoader
        open={isLoading}
        alt={loadingMsg}
        text={loadingMsg}
        customClass="loading-in-auth"
      />
      {!isLoading && (
        <CommonAuthHeader shouldShowBackButton={false}>
          <LinkStatus from="verifyEmail" type={linkStatus} email={email} />
        </CommonAuthHeader>
      )}
    </>
  ) : (
    verifyEmailScreen && (
      <CommonAuthHeader>
        <EmailVerification />
      </CommonAuthHeader>
    )
  );
};

export default OptionsEmailVerification;
